import moment from 'moment'

export default {
  data() {
    return {
      postDate: null,
      schedule: false,
    }
  },
  computed: {
    schedulePostDate() {
      if (this.parentPost && this.parentPost.ScheduledDate && this.parentPost.ScheduledDate !== 'NULL') {
        return moment(this.parentPost.ScheduledDate).format('DD/MM/YYYY HH:mm')
      }
      return this.parentPost ? this.parentPost.PostCreatedDate_convert : ''
    },
  },
  methods: {
    initScheduleDate(post) {
      if (!this.postDate && post.ScheduledDate && post.ScheduledDate !== 'NULL') {
        this.postDate = moment(post.ScheduledDate).toDate()
      }
    },
    handleSchedule(status) {
      if (status) {
        this.schedule = status
      } else {
        this.schedule = !this.schedule
      }
    },
  },
}
